// AuthContext.js
import React, { createContext, useState, useEffect, useCallback } from "react";

// Create the context
export const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    username: "",
    password: "",
    userrole: "",
    access_token: "",
    refresh_token: "",
    token_type: "",
  });
  const [organisationId, setOrganisationId] = useState(1);
  const [projectId, setProjectId] = useState(1);
  const [userInfo, setUserInfo] = useState(null);

  // for testing
  const initialData = {
    name: "test",
  };

  useEffect(() => {
    const storedAuthData = JSON.parse(sessionStorage.getItem("loginData"));
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (storedAuthData) {
      const updatedVals = { ...authData, ...storedAuthData };
      // Use functional update to avoid dependency on authData
      setAuthData(updatedVals);
    }
    if (storedUserInfo) {
      setUserInfo(storedUserInfo);
    }
  }, []);

  const login = (e) => {
    setAuthData({ ...authData, [e.target.name]: e.target.value });
  };

  const logout = () => {
    setAuthData(null);
    sessionStorage.removeItem("loginData");
    sessionStorage.removeItem("userInfo");
  };

  const hasPermission = useCallback(
    (permission) => {
      return (
        userInfo &&
        userInfo.permissions &&
        userInfo.permissions.includes(permission)
      );
    },
    [userInfo]
  );

  const hasAnyPermission = useCallback(
    (permissions) => {
      return (
        userInfo &&
        userInfo.permissions &&
        permissions.some((permission) =>
          userInfo.permissions.includes(permission)
        )
      );
    },
    [userInfo]
  );

  const getUserType = () => {
    return userInfo?.role_name || null;
  };

  return (
    <AuthContext.Provider
      value={{
        initialData,
        authData,
        organisationId,
        projectId,
        userInfo,
        setAuthData,
        login,
        logout,
        setUserInfo,
        hasPermission,
        hasAnyPermission,
        setProjectId,
        setOrganisationId,
        getUserType,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
